<script setup>
import { useDetectDevice } from '@/composables/device'

import GroupsView from '@/components/planner/GroupsView.vue'
import GroupsGrid from '@/components/planner/GroupsGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <groups-view v-if="isMobile" />
  <groups-grid v-else />
</template>
